<template>
  <div class="col-12 box-col-6 product-listing-page">
    <div class="email-left-aside" id="ProductInfo_Management">
      <b-overlay :show="isLoading" rounded="sm">
        <b-card no-body>
          <div class="title" v-if="!fromAdmin">{{ $t('lbl_EMPBE_ProductInfo_Title') }}</div>
          <b-tabs card @input="onInput">
            <div>
           
              <b-tab  :active="currentTab === 0"
                :title-link-attributes="{ 't_label': 'EMPBE_ProductInfoCenter_tab_Product' }">
                <template #title>
                  <span class="tab-title-with-dot">
                    <span class="tab-title-text">
                      {{ $t("lbl_EMPBE_ProductInfo_ProductGrid_TabProduct", { totalNumberOfProducts: GetRecordsEffective, MaxQuota: otherInfo.product_TotalQty }) }}
                    </span>
                    <TipsAndPrivewDilog
                      :id="'EMPBE_ProductInfo_ProductGrid_TabProduct_Info'"
                      :Title="$t('lbl_EMPBE_ProductInfo_ProductGrid_TabProduct_Tooltip')"
                    />
                    <span v-if="showProductTabWarningDot" class="tab-warning-dot"></span>
                  </span>
                </template>
                <div class="email-app-sidebar left-bookmark" style="height: auto">
                  <div class="media"></div>
                  <ul class="nav main-menu" role="tablist">
                    <li class="nav-item">
                      <productGrid ref="productGrid" :addToCart="addToCart" :Records="productList" :otherInfo="otherInfo" 
                      :fromAdmin="fromAdmin"
                      :totalCount="productTotalCount"
                       @refreshGrid="fetchData" 
                       @fetch="onProductGridFetch"
                       @row-click="handleRowClick" 
                       ></productGrid>
                    </li>
                  </ul>
                </div>
              </b-tab>
              <b-tab active :title-item-class="{ 'd-none': !isShowCatalog }" :active="currentTab === 1"
                :title-link-attributes="{ 't_label': 'EMPBE_ProductInfoCenter_tab_Info' }">
                <template #title>
                  {{ $t("lbl_EMPBE_ProductInfo_ProductGrid_TabCatalog", { totalNumberOfProducts:  otherInfo.directory_LaunchedCount, MaxQuota: otherInfo.directory_TotalQty }) }}
                </template>
                <div class="email-app-sidebar left-bookmark" style="height: auto">
                  <div class="media"></div>
                  <ul class="nav main-menu" role="tablist">
                    <li class="nav-item">
                      <visitorPermission :Permission="isShowCatalog">
                        <template v-slot:body>
                          <catalogGrid ref="catalogGrid" :addToCart="addToCart" :Records="indexList" 
                          :otherInfo="otherInfo"  @refreshGrid="fetchData" @row-click="handleRowClick" 
                          :fromAdmin="fromAdmin"
                          ></catalogGrid>
                        </template>
                      </visitorPermission>
                    </li>
                  </ul>
                </div>
              </b-tab>
            </div>
          </b-tabs>
        </b-card>

      </b-overlay>
      <b-sidebar id="OrderRightpopup" class="customSidebar" title="" right bg-variant="white" :shadow="true" backdrop
        :visible="false" ref="OrderRightpopup">
        <productOrdering :currentTab="currentTab" :productList="productList" :indexList="indexList"></productOrdering>
      </b-sidebar>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { productService, resolveProductRowStatus, resolveProductLaunchStatus, hasProductListDraftIndicator, productOccupiesApprovalQuota, PRODUCT_DISPLAY_STATUS, PRODUCT_LAUNCH_STATUS, unwrapProductListPayload } from '@/_services/product.service';
import productOrdering from './productOrdering.vue'
import productGrid from './productGrid.vue';
import catalogGrid from './catalogGrid.vue';

export default {
  inject: {
    permissionData: { default: null },
    ChildSubmit: { default: null },
  },
  props: ['selectTab','hideSidebarNavMenu',"supplierId","fromAdmin","submitType"],
  components: {
    productOrdering: productOrdering,
    productGrid: productGrid,
    catalogGrid: catalogGrid
  },
  data() {
    return {
      isShowCatalog: true,
      isProductListLoading: true,
      isProductCatalogLoading: true,
      items: null,
      error: null,
      productList: [],
      productTotalCount: 0,
      listQuery: {
        pageNumber: 1,
        pageSize: 10,
        keyword: '',
        productId: null,
        isMainProduct: null,
        launchStatus: '',
        reviewStatus: '',
        sortField: '',
        sortDir: '',
      },
      indexList: [],
      otherInfo: {
        product_PayTotalQty: 0,
        product_TotalQty: 0,
        product_LaunchedCount: 0,
        product_OccupiedCount: 0,
        directory_PayTotalQty: 0,
        directory_TotalQty: 0,
        directory_LaunchedCount: 0,
      },
      kendoGrid:{
        pageCount:10,//一页显示多少条
        currentPage:0
      },
      currentTab: 0,
      catalogLoaded: false,
      cdnUrl:'https://cdn.adsalecdn.com/EMP/Backend/svg/',
      unsubmittedProductCount: 0,
      pendingManualProductCount: 0,
      rejectedProductCount: 0,
    };
  },
  computed: {
    useFormalTables() {
      return String(this.submitType || 'edit').toLowerCase() === 'approval';
    },
    ...mapGetters({
      getPaymentItemById: 'paymentItem/getPaymentItemById',
      getCartPaymentItemById: 'paymentItem/getCartPaymentItemById',
    }),
    GetRecordsEffective(){
            return this.otherInfo.product_OccupiedCount || 0;
    },
    langid() {
      return localStorage.getItem("currentLangId")
    },
    user() {
      return this.$store.state.authentication.user;
    },
    companyid() {
      //return this.user.empCompanyId;  
      const empCompanyId = this.user && this.user.empCompanyId;
      return this.supplierId === null ||
        this.supplierId === undefined ||
        this.supplierId === ""
        ? empCompanyId
        : this.supplierId;
    
    },

    isLoading() {
      // Check the current tab and return the loading status of the tab
      return this.currentTab === 0
        ? this.isProductListLoading
        : this.currentTab === 1
          ? this.isProductCatalogLoading
          : false;
    },
    showProductTabWarningDot() {
      // 供应商端草稿已在列表行内展示「草稿」标签，Tab 不再显示黄点；仅管理端提示待人工审批
      return this.fromAdmin && this.pendingManualProductCount > 0;
    },
  },
  created() {  
    if(this.$route.query.tab)
    {
     this.currentTab=this.$route.query.tab.toLowerCase()=='catalog'?1:0; 
    }
    
    // watch the params of the route to fetch the data again
    this.$watch(
      () => this.$route.params,
      () => {
      //  if (!this.fetchedData) {
          this.fetchData();
          this.productListDragula();
       // }
      },
      // fetch the data when the view is created and the data is
      // already being observed
      { immediate: true }
    );
    this.initData();
    this.initPermissionData();
  },
  watch: {
    
  // '$route'(){
  //   this.ChangeTabByRouter();
  //   },
    permissionData: {
      handler() {
        this.initPermissionData();
      },
      deep: true
    },
    // '$route'(to, from) {
    //     if(from.path.includes('productDetail') || from.path.includes('indexDetail'))
    //     {
    //         this.loadData();
    //     }
    //   },
  },
  mounted() {
   // this.ChangeTabByRouter();
    // 监听子组件的刷新事件
    //this.$on('fetchData', this.fetchData);
    
  },
  methods: {
    handleRowClick({ productOrCatalogId,type }) {
      // 如果是管理员模式，向上传递事件给父组件
      if (this.fromAdmin) { 
        this.$emit('row-click', { productOrCatalogId,type });
      }
    },
    // handleRowClick_Catalog({ productId }) {
    //   // 如果是管理员模式，向上传递事件给父组件 
    //   if (this.fromAdmin) {
    //      let type='catalog'
    //     this.$emit('row-click', { productId,type });
    //   }
    // },
    initPermissionData() {
      if (this.permissionData != null) {
        this.isShowCatalog = ['A+','A','B','C'].includes(this.permissionData['Type']);
      }
    },
    initData() {
      var that = this;
      productService.getSysAccountPaymentInfo({ CompanyId: this.companyid, demodate: '' }).then((res) => {
        if (res.isSuccessful) {
          console.log('res.data');
          console.log(res.data);
          if (res.data != null) {
            let data = res.data;
            if (data.length > 0) {
              data.forEach(element => {
                if (element.rid === 1) {
                  that.otherInfo.product_PayTotalQty = element.payTotalQty;
                  that.otherInfo.product_TotalQty = element.totalQty;
                }
                if (element.rid === 2) {
                  that.otherInfo.directory_PayTotalQty = element.payTotalQty;
                  that.otherInfo.directory_TotalQty = element.totalQty;
                }
              });
            }
          }

        }
      });
    },
    productListDragula() {
      let dragula = this.$dragula;
      let service = dragula.createService({
        name: 'product',
        drake: {
          copy: true,
        },
      });
      service.on({
        'product:dropModel': ({
          name,
          el,
          source,
          target,
          dragIndex,
          dropIndex,
          sourceModel,
        }) => {
          el.classList.add('ex-moved');
          if (name == 'product' && dragIndex != dropIndex) {
            var productId = el.attributes.id.value;
            productService
              .saveProdutDetailIndex({
                companyId: this.companyid,
                productId: productId,
                old_index: dragIndex,
                new_index: dropIndex,
              })
              .then((res) => {
                if (res.isSuccessful) {
                  this.$swal({
                    text: this.$t('lbl_EMPBE_ChangeProdOrder'),
                  });
                }
              });
          }
          if (name == 'index' && dragIndex != dropIndex) {
            var catalogId = el.attributes.id.value;
            productService
              .saveProdutCatalogDetailIndex({
                companyId: this.companyid,
                catalogId: catalogId,
                old_index: dragIndex,
                new_index: dropIndex,
              })
              .then((res) => {
                if (res.isSuccessful) {
                  this.$swal({
                    text: this.$t('lbl_EMPBE_ChangeIndexOrder'),
                  });
                }
              });
          }
        },
      });
    },
    fetchData() {
      this.error = this.items = null;
      this.isProductListLoading = true;
      this.fetchedData = true;
      this.loadProductList();
      if (this.currentTab === 1) {
        this.catalogLoaded = false;
        this.loadProductCatalog();
      } else {
        this.isProductCatalogLoading = false;
      }
    },
    loadData() {
      console.log('getProdutListAsync-this.companyid'+this.companyid)
      this.loadProductList();
      if (this.currentTab === 1) {
        this.loadProductCatalog();
      } else {
        this.isProductCatalogLoading = false;
      }
    },
    loadProductCatalog() {
      if (this.catalogLoaded && this.indexList.length > 0) {
        this.isProductCatalogLoading = false;
        return;
      }
      this.isProductCatalogLoading = true;
      this.catalogLoaded = true;
      //获取产品目录列表
      productService
        .getProdutCatalogListAsync({ companyId: this.companyid,langId: this.langid })
        .then((res) => {
          console.log('this.companyid'+this.companyid+'getProdutCatalogList'+res);
          if (res.isSuccessful) {
            this.indexList = [];
            this.otherInfo.directory_LaunchedCount = 0;
            var currentLangData = res.data;//.filter(x => x.name != '' && x.langId == that.langid)
            currentLangData.forEach((item) => {

            if(item.isLaunch){
               this.otherInfo.directory_LaunchedCount+= 1; 
            }

              var _item = {
                id: item.catalogId,
                langid: item.langId,
                converFileName:item.converFileName?item.converFileName+`?x-oss-process=image/resize,w_28,h_40,m_pad/format,webp`:this.cdnUrl+'ProductInfo/NoImage.svg',
                name: item.name,
                statusClass: item.isLaunch
                  ? 'badge-light-success'
                  : 'badge-light',
                orederId: item.orderId,
                spanIsLaunch: item.isLaunch,
                lastSubmitDate: item.submitDate.toString()=='-'?item.submitDate:item.submitDate.substring(0, item.submitDate.length-3),
                lastSaveDate: item.saveDate.toString()=='-'?item.saveDate:item.saveDate.substring(0, item.saveDate.length-3), 
                state:this.GetPageState(item.submitDate.replace('-',''),item.saveDate.replace('-',''),item.isLaunch)
              };
              this.indexList.push(_item);
            });
           
            console.log('indeli', this.indexList);
          }
        })
        .finally(() => {
          this.isProductCatalogLoading = false;
          if(this.seelctTab)
            {
            this.currentTab= this.selectTab
            }
        });
    },
    onProductGridFetch(query) {
      this.listQuery = Object.assign({}, this.listQuery, query || {});
      this.loadProductList();
    },
    loadProductList() {
      this.isProductListLoading = true;
      const q = this.listQuery || {};
      productService
        .getProdutListAsync({
          companyId: this.companyid,
          keyword: q.keyword || null,
          productId: (q.productId && String(q.productId).trim()) ? String(q.productId).trim() : null,
          isMainProduct: q.isMainProduct === null || q.isMainProduct === undefined || q.isMainProduct === ''
            ? null
            : q.isMainProduct,
          launchStatus: q.launchStatus || null,
          reviewStatus: q.reviewStatus || null,
          sortField: q.sortField || null,
          sortDir: q.sortDir || null,
          pageNumber: q.pageNumber || 1,
          pageSize: q.pageSize || 10,
          useFormalTables: this.useFormalTables,
        })
        .then((res) => {
          if (res.isSuccessful) {
            this.productList = [];
            const { items: rows, totalCount, onlineCount, unsubmittedCount, pendingManualAuditCount, rejectedCount, occupiedCount } = unwrapProductListPayload(res.data);
            this.productTotalCount = totalCount;
            this.otherInfo.product_LaunchedCount = onlineCount != null ? onlineCount : 0;
            this.unsubmittedProductCount = Number(unsubmittedCount || 0);
            this.pendingManualProductCount = Number(pendingManualAuditCount || 0);
            this.rejectedProductCount = Number(rejectedCount || 0);

            // 额度占用：展示状态 + 提交状态联合判断（见 productOccupiesApprovalQuota）
            this.otherInfo.product_OccupiedCount = occupiedCount != null
              ? Number(occupiedCount)
              : rows.filter((item) => productOccupiesApprovalQuota({
                approvalStatusCode: item.approvalStatusCode ?? item.ApprovalStatusCode,
                isLaunch: item.isLaunch ?? item.IsLaunch,
              })).length;

            rows.forEach((item) => {
              const approvalStatusCode = item.approvalStatusCode ?? item.ApprovalStatusCode ?? null;
              const displayStatus = this.resolveListDisplayStatus(item, approvalStatusCode);
              const launchStatus = resolveProductLaunchStatus({
                approvalStatusCode,
                isLaunch: item.isLaunch ?? item.IsLaunch,
              });
              const rawRate = item.completeRate ?? item.CompleteRate;
              const completeRate = rawRate === null || rawRate === undefined || rawRate === '' || rawRate === '-'
                ? null
                : Math.min(100, Math.max(0, Math.round(Number(rawRate))));
              const lastSubmitDate = item.lastSubmitDate ?? item.LastSubmitDate ?? '-';
              const lastSaveDate = item.lastSaveDate ?? item.LastSaveDate ?? '-';
              const showDraftPill = hasProductListDraftIndicator({
                displayStatus,
                lastSaveDate,
                lastSubmitDate,
              });
              var _item = {
                id: item.productId ?? item.ProductId,
                imgFileUrl: (item.imgFileUrl || item.ImgFileUrl)
                  ? (item.imgFileUrl || item.ImgFileUrl) + `?x-oss-process=image/resize,h_40/format,webp`
                  : this.cdnUrl + 'ProductInfo/NoImage.svg',
                name: this.langid == 1252
                  ? (item.exhibitNameE ?? item.ExhibitNameE)
                  : (this.langid == 936 ? (item.exhibitNameS ?? item.ExhibitNameS) : (item.exhibitNameT ?? item.ExhibitNameT)),
                IsLaunch: item.isLaunch ?? item.IsLaunch,
                isFire: item.isMainProduct ?? item.IsMainProduct,
                EmpCompanyId: item.empCompanyId ?? item.EmpCompanyId,
                OrderId: item.orderId ?? item.OrderId,
                productId: item.productId ?? item.ProductId,
                lastSubmitDate: lastSubmitDate.toString() == '-'
                  ? lastSubmitDate
                  : lastSubmitDate.toString().substring(0, lastSubmitDate.toString().length - 3),
                lastSaveDate: lastSaveDate.toString() == '-'
                  ? lastSaveDate
                  : lastSaveDate.toString().substring(0, lastSaveDate.toString().length - 3),
                approvalStatusCode,
                displayStatus,
                launchStatus,
                completeRate: Number.isFinite(completeRate) ? completeRate : null,
                showDraftPill,
                state: this.mapDisplayStatusToState(displayStatus)
              };
              this.productList.push(_item);
            });
          }
        })
        .finally(() => {
          this.isProductListLoading = false;
        });
    },
    //Add to cart
    addToCart: function (sku, qty) {
      //close right popup
      this.hideSidebarNavMenu();

      var product = this.getCartPaymentItemById(sku);
      if (product != undefined) {
        this.$store.dispatch('paymentItem/updateCartQuantity', {
          product: product,
          qty: 1,
        });
      } else {
        product = this.getPaymentItemById(sku);
        product.quantity = qty ? qty : 1;
        this.$store.dispatch('paymentItem/addToCart', product);
      }
      this.cart_open();
    },
    cart_open() {
      this.$store.dispatch('paymentItem/toggleCart', true);
    },
    onInput(value) {
     
      const previousTab = this.currentTab;
      this.currentTab = value;
      
      // 当切换 tab 时，重置分页状态
      this.$nextTick(() => {
        console.log('input',value);
        if (previousTab !== value) {
          if (value === 0 && this.$refs.productGrid) {
            this.$refs.productGrid.skip = 0;
            this.$refs.productGrid.take = this.listQuery.pageSize || 10;
          } else if (value === 1) {
            this.loadProductCatalog();
            if (this.$refs.catalogGrid) {
              this.$refs.catalogGrid.skip = this.kendoGrid.currentPage;
              this.$refs.catalogGrid.take = this.kendoGrid.pageCount;
              if (this.$refs.catalogGrid.items && this.$refs.catalogGrid.getData) {
                this.$refs.catalogGrid.gridData = this.$refs.catalogGrid.getData(this.$refs.catalogGrid.items);
              }
            }
          }
        }
      });
    },
     GetPageState(lastSubmitDate,lastSaveDate,isLaunch) {
     if (isLaunch == true||isLaunch == 1) { 
        //上架
        return 1;
      }
      else if (!lastSubmitDate||(lastSubmitDate&&lastSaveDate&&lastSaveDate>lastSubmitDate)) {
        //下架之后再次保存，状态变为草稿（新加）
        return 0 ;//草稿
      }
      else {
      
        return 2;//下架
      }
    },
    resolveListDisplayStatus(item, approvalStatusCode) {
      // Review Status 只跟审批状态走，与详情页 resolveProductRowStatus 一致
      // 不再用 isLaunch 回退成 Activated（上架归 Products Status）
      return resolveProductRowStatus({ statusCode: approvalStatusCode });
    },
    mapDisplayStatusToState(displayStatus) {
      if (displayStatus === PRODUCT_DISPLAY_STATUS.live) return 1;
      if (displayStatus === PRODUCT_DISPLAY_STATUS.pending) return 3;
      if (displayStatus === PRODUCT_DISPLAY_STATUS.pendingManualAudit) return 4;
      if (displayStatus === PRODUCT_DISPLAY_STATUS.rejected) return 5;
      if (displayStatus === 'delisted') return 2;
      return 0;
    },

  
  
  },
};
</script>
<style>
/* .card .router-link-exact-active {
  background-color: #e2e2e2;
  text-decoration: none;
} */

.no-router-link-exact-active {
  background-color: unset !important;
}



b-tab .d-none {
  display: none !important;
}
</style>
<style lang="scss">
.product-listing-page {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

#ProductInfo_Management { 
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;

  .card {
    /* Contain table overflow; do not touch card-header tabs */
    overflow: hidden;
  }

  /* Only constrain tab BODY / grid wrappers — never .card-header .nav-item (Product / Catalog tabs) */
  .card-body,
  .tab-content,
  .tab-pane {
    max-width: 100%;
    min-width: 0;
  }

  .card-body .email-app-sidebar,
  .card-body .main-menu,
  .card-body .nav-item,
  .card-body .b-overlay-wrap {
    width: 100%;
    max-width: 100%;
    min-width: 0 !important;
    box-sizing: border-box;
  }

  .k-grid td,
  .k-grid th {
    padding: 8px !important;
  }
  .tab-title-with-dot {
    display: inline-flex;
    align-items: center;
    gap: 2px;
    white-space: nowrap;

    .TipsAndPrivewDilog {
      display: inline-flex;
      align-items: center;
      flex-shrink: 0;
      vertical-align: middle;
    }
  }

  .tab-warning-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #ffd02c;
    display: inline-block;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08);
  }
  .tab-warning-badge {
    min-width: 16px;
    height: 16px;
    padding: 0 4px;
    border-radius: 8px;
    background: #ffd02c;
    color: rgba(0, 0, 0, 0.8);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    font-weight: 700;
    line-height: 1;
  }
  .card .card-header:nth-child(1) {
    margin-left: unset;
    width: unset;
  }

  .card .card-body {
    padding: 0px 32px 32px 32px;
    background-color: transparent;
  }

  .title {
    padding: 32px 32px 0px 32px;
    color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%;
    /* 36px */
    letter-spacing: -0.264px;
  }

  .export-buttons {
    margin-left: auto;
    margin-right: 0;
    position: absolute;
    right: 1px;
    top: -50px;
  }
  .card-header-tabs .nav-link {
    display: block;
    padding: 12px 16px;
    border: unset;
    border-bottom: 1px solid #e2e2e2;
    border-radius: 4px 4px 0 0;
    color: rgba(0, 0, 0, 0.80);
    font-size: 14px;
    font-weight: 400;
    line-height: 1.3;
    background-color: transparent;
    transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;

    .tab-title-with-dot,
    span {
      color: inherit;
      font-size: inherit;
      font-weight: inherit;
      margin-top: 0;
      letter-spacing: normal;
    }

    &:hover:not(.active) {
      background-color: rgba(0, 0, 0, 0.03);
      color: rgba(0, 0, 0, 0.80);
    }

    &.active {
      color: #7366FF;
      font-weight: 600;
      background-color: #fff;
      border-bottom: 1.5px solid #7366FF;
    }
  }
    // .card-header-tabs{
    // margin-left: 8px;
    // }
}
</style>